<template>
  <v-container id="citygroup-edit" fluid tag="section">
    <v-card>
      <v-form id="form" class="px-5 pt-5">
        <v-row>
          <v-col cols="12" md="6" lg="6">
            <z-fund-account-select
              multiple="false"
              v-model="acTrans.fundAC_id"
              :label="$i18n.t('Account Select')"
            />
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <z-date-picker
              :label="$i18n.t('Transaction Date')"
              v-model="acTrans.transactionDate"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="6" lg="6">
            <v-text-field
              v-model="acTrans.credit"
              placeholder="Credit Amount"
              type="number"
              :label="$i18n.t('Credit')"
            />
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <v-text-field
              v-model="acTrans.debit"
              placeholder="Debit Amount"
              type="number"
              :label="$i18n.t('Debit')"
            />
          </v-col>
          <v-row>
            <v-col>
              <v-text-field
                v-model="acTrans.referenceNo"
                placeholder="Reference"
                :label="$i18n.t('Reference')"
              />
            </v-col>
          </v-row>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-right mb-5">
            <v-btn
              color="success"
              class="mr-0"
              @click="save()"
              :loading="loading"
            >
              <h3>{{ $i18n.t("Save") }}</h3>
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class AcTransEdit extends Vue {
  acTrans = {
    fundAC_id: null,
    debit: null,
    credit: null,
    referenceNo: null,
    transactionDate: null,
  };

  @Watch("acTrans")
  co() {
    console.log(this.acTrans);
  }
  id = null;

  get loading() {
    return common.loading;
  }

  validateSave() {
    if (!this.acTrans.fundAC_id) {
      common.setError("Please Select Account");
      return false;
    }
    if (!this.acTrans.transactionDate) {
      common.setError("Please Enter Transaction Date");
      return false;
    }
    if (
      (!this.acTrans.debit && !this.acTrans.credit) ||
      (this.acTrans.debit && this.acTrans.credit)
    ) {
      common.setError("Invalid credit or debit");
      return false;
    }

    return true;
  }

  async save() {
    try {
      if (!this.validateSave()) return;
      common.setLoading(true);
      const response = await doPost("/api/account/txn/add", this.acTrans);
      if (!this.id) this.$router.push("/settings/transactions/" + response._id);
      this.get(response._id);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async get(id) {
    try {
      const response = await doGet("/api/account/txn/" + id + "/detail");
      if (!response.cities) response.cities = [];
      this.acTrans = response;
      this.id = this.acTrans._id;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async mounted() {
    if (this.$route.params.id) {
      await this.get(this.$route.params.id);
    }
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}

.custom-justify-content-center {
  display: flex;
  justify-content: center;
}
</style>
